import React from 'react';

import { IconProps, StyledSvg } from '../iconCommons';

export const IconChevron = ({ color = 'currentColor', size = 'xSmall', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" size={size} {...props}>
        <path
            d="M1.22912 1.3125L5.69579 5.77917C5.72482 5.80815 5.74784 5.84258 5.76356 5.88047C5.77927 5.91836 5.78735 5.95898 5.78735 6C5.78735 6.04102 5.77927 6.08164 5.76356 6.11953C5.74784 6.15742 5.72482 6.19185 5.69579 6.22083L1.22912 10.6875"
            stroke={color}
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </StyledSvg>
);
